<div class="control-view-type">
  <button *ngIf="false"
    class="button-view-mode"
    [ngClass]="{ active: mobileOnly }"
    (click)="changePreviewType('CARD')"
    mat-icon-button
    id="btn-view-mode-card"
  >
    <mat-icon>view_module</mat-icon>
  </button>
  <button *ngIf="false"
    id="btn-view-mode-grid"
    class="button-view-mode"
    [ngClass]="{ active: desktopOnly }"
    mat-icon-button
    (click)="changePreviewType('GRID')"
  >
    <mat-icon>view_list</mat-icon>
  </button>
</div>
